module.exports = __webpack_public_path__ + "img/1552281108.ca0eed9d.jpg";